// project
import { shuffle } from "@/utils/array";
import * as Random from "@/utils/random";
// local
import { SARTParams } from "../types/SARTParams";

export const generateSART = (params:SARTParams) => {
	const { values, stimulus, targetValue } = params;
	const targetCount = parseInt((values * stimulus).toString());
	const sequence:number[] = [];
	sequence.length = values;
	const nonTargets = [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9 ];
	nonTargets.splice(targetValue, 1);
	let i = 0;
	for(; i < targetCount; i++) { sequence[i] = targetValue; }
	for(; i < sequence.length; i++){ sequence[i] = nonTargets[Random.range(0, 9)]; }
	shuffle(sequence);
	return sequence;
};